/* ==========================================================================
   Martine & René — kleine scripts bovenop Impulse 7.1
   - aftelbalk (alleen naar een echte einddatum)
   - verzenddatum in de grijze pil
   - kleurnaam naast "Couleur"
   - groene kortingsbadge bij variantwissel
   - reviewslider-pijlen en doorlopende fotostroken
   - winkelmand-lade: staffelbalk, totalen en verwijderknop
   ========================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function formatMoney(cents) {
    var format = (window.theme && theme.settings && theme.settings.moneyFormat) || '€{{amount_with_comma_separator}}';
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ------------------------------------------------------------------------
     Aftelbalk
     ------------------------------------------------------------------------ */
  function parisDate(y, m, d, h, mi) {
    // Zet een tijdstip in Parijse tijd om naar een echte Date.
    var guess = Date.UTC(y, m - 1, d, h, mi);
    try {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Paris',
        hour12: false,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
      var parts = {};
      fmt.formatToParts(new Date(guess)).forEach(function (p) {
        parts[p.type] = p.value;
      });
      var asParis = Date.UTC(+parts.year, +parts.month - 1, +parts.day, (+parts.hour) % 24, +parts.minute);
      return new Date(guess - (asParis - guess));
    } catch (e) {
      return new Date(y, m - 1, d, h, mi);
    }
  }

  function parseEnd(value) {
    if (!value) return null;
    var m = String(value).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return null;
    var h = m[4] ? +m[4] : 23;
    var mi = m[5] ? +m[5] : 59;
    return parisDate(+m[1], +m[2], +m[3], h, mi);
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function initCountdown(bar) {
    if (bar.dataset.mrReady) return;
    bar.dataset.mrReady = '1';
    var end = parseEnd(bar.dataset.end);
    var live = bar.querySelector('[data-mr-live]');
    var idle = bar.querySelector('[data-mr-idle]');
    var timer = bar.querySelector('[data-mr-timer]');
    var dayWord = bar.dataset.dayWord || 'j';

    function showIdle() {
      if (live) live.hidden = true;
      if (idle) idle.hidden = false;
      var idleEmpty = !idle || !idle.textContent.trim();
      if (bar.dataset.hideAfter === 'true' || idleEmpty) bar.hidden = true;
    }

    if (!end || !timer) {
      showIdle();
      return;
    }

    function tick() {
      var diff = Math.floor((end.getTime() - Date.now()) / 1000);
      if (diff <= 0) {
        showIdle();
        return false;
      }
      var days = Math.floor(diff / 86400);
      var hours = Math.floor((diff % 86400) / 3600);
      var minutes = Math.floor((diff % 3600) / 60);
      var seconds = diff % 60;
      timer.textContent = (days > 0 ? days + dayWord + ' ' : '') + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
      if (live) live.hidden = false;
      if (idle) idle.hidden = true;
      return true;
    }

    if (tick()) {
      var interval = setInterval(function () {
        if (!tick()) clearInterval(interval);
      }, 1000);
    }
  }

  /* ------------------------------------------------------------------------
     Verzenddatum
     ------------------------------------------------------------------------ */
  function initEta(el) {
    var days = parseInt(el.dataset.days, 10);
    if (isNaN(days)) days = 2;
    var skipWeekend = el.dataset.skipWeekend === 'true';
    var date = new Date();
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (skipWeekend && (day === 0 || day === 6)) continue;
      added++;
    }
    if (skipWeekend) {
      while (date.getDay() === 0 || date.getDay() === 6) date.setDate(date.getDate() + 1);
    }
    var locale = el.dataset.locale || document.documentElement.lang || 'fr';
    var weekday = '';
    try {
      weekday = date.toLocaleDateString(locale, { weekday: 'short' });
    } catch (e) {
      weekday = '';
    }
    weekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);
    if (weekday && weekday.slice(-1) !== '.') weekday += '.';
    var label = (weekday ? weekday + ' ' : '') + pad(date.getDate()) + '/' + pad(date.getMonth() + 1);
    var target = el.querySelector('[data-mr-eta-date]');
    if (target) target.textContent = label;
  }

  /* ------------------------------------------------------------------------
     Kleurnaam + kortingsbadge bij variantwissel
     ------------------------------------------------------------------------ */
  function bindVariantLabels(root) {
    root.querySelectorAll('.mr-variant--color').forEach(function (wrap) {
      if (wrap.dataset.mrReady) return;
      wrap.dataset.mrReady = '1';
      var target = wrap.querySelector('[data-mr-option-value]');
      if (!target) return;
      wrap.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.addEventListener('change', function () {
          if (input.checked) target.textContent = input.value;
        });
      });
    });
  }

  document.addEventListener(
    'variantChange',
    function (evt) {
      var container = evt.target;
      if (!container || !container.querySelectorAll) return;
      var detail = evt.detail || {};
      var variant = detail.variant;

      // Kleurnaam bijwerken (ook als het thema de keuze automatisch aanpast)
      container.querySelectorAll('.mr-variant--color').forEach(function (wrap) {
        var target = wrap.querySelector('[data-mr-option-value]');
        var checked = wrap.querySelector('input[type="radio"]:checked');
        if (target && checked) target.textContent = checked.value;
      });

      if (!variant) return;
      container.querySelectorAll('[data-mr-badge]').forEach(function (badge) {
        var compare = variant.compare_at_price || 0;
        var price = variant.price || 0;
        if (compare > price) {
          var saved = compare - price;
          var amount = badge.dataset.type === 'percent'
            ? Math.round((saved * 100) / compare) + '%'
            : formatMoney(saved);
          badge.textContent = (badge.dataset.prefix ? badge.dataset.prefix + ' ' : '') + amount;
          badge.classList.remove('hide');
        } else {
          badge.classList.add('hide');
        }
      });
    },
    true
  );

  /* ------------------------------------------------------------------------
     Reviewslider
     ------------------------------------------------------------------------ */
  function initReviews(section) {
    if (section.dataset.mrReady) return;
    section.dataset.mrReady = '1';
    var track = section.querySelector('[data-mr-track]');
    var prev = section.querySelector('[data-mr-prev]');
    var next = section.querySelector('[data-mr-next]');
    if (!track) return;

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ------------------------------------------------------------------------
     Doorlopende strook (foto's / logo's)
     ------------------------------------------------------------------------ */
  function initMarquee(root) {
    if (root.dataset.mrReady) return;
    var track = root.querySelector('.mr-marquee__track');
    if (!track || !track.children.length) return;
    root.dataset.mrReady = '1';
    var originals = Array.prototype.slice.call(track.children);
    var guard = 0;
    var minWidth = Math.max(root.clientWidth, window.innerWidth || 0);
    while (track.scrollWidth < minWidth && guard < 8) {
      originals.forEach(function (item) {
        var copy = item.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        track.appendChild(copy);
      });
      guard++;
    }
    var clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    root.appendChild(clone);
  }

  /* ------------------------------------------------------------------------
     Winkelmand-lade
     ------------------------------------------------------------------------ */
  function cartData(drawer) {
    var items = drawer.querySelector('[data-products] .cart__items');
    if (!items) return null;
    return {
      count: parseInt(items.dataset.count, 10) || 0,
      total: parseInt(items.dataset.cartSubtotal, 10) || 0,
      compare: parseInt(items.dataset.mrCompareTotal, 10) || 0
    };
  }

  function plural(n, one, many) {
    return n === 1 ? one : many;
  }

  function renderTiers(drawer, data) {
    var box = drawer.querySelector('[data-mr-tiers]');
    if (!box || !data) return;
    var tiers = [];
    box.querySelectorAll('[data-mr-node]').forEach(function (node) {
      tiers.push({ el: node, count: parseInt(node.dataset.count, 10) || 0, label: node.dataset.label || '' });
    });
    if (!tiers.length) return;
    var max = tiers[tiers.length - 1].count || 1;
    var count = data.count;
    var fill = box.querySelector('[data-mr-fill]');
    if (fill) fill.style.width = Math.min(100, (count / max) * 100) + '%';
    var nextTier = null;
    tiers.forEach(function (t) {
      var reached = count >= t.count;
      t.el.classList.toggle('is-reached', reached);
      if (!reached && !nextTier) nextTier = t;
    });
    var msg = box.querySelector('[data-mr-msg]');
    if (msg) {
      if (!nextTier) {
        msg.innerHTML = box.dataset.textComplete || '';
      } else {
        var missing = nextTier.count - count;
        var unit = plural(missing, box.dataset.unitOne || 'article', box.dataset.unitMany || 'articles');
        var tpl = box.dataset.textProgress || '';
        msg.innerHTML = tpl
          .replace('[nombre]', '<strong>' + missing + ' ' + unit + '</strong>')
          .replace('[remise]', '<strong>' + nextTier.label + '</strong>');
      }
      msg.hidden = !msg.innerHTML;
    }
  }

  function renderTotals(drawer, data) {
    if (!data) return;
    var save = drawer.querySelector('[data-mr-total-save]');
    var compare = drawer.querySelector('[data-mr-total-compare]');
    var saved = data.compare - data.total;
    if (save) {
      if (saved > 0) {
        save.textContent = '(' + (save.dataset.label || '') + ' ' + formatMoney(saved) + ')';
        save.hidden = false;
      } else {
        save.hidden = true;
      }
    }
    if (compare) {
      if (saved > 0) {
        compare.textContent = formatMoney(data.compare);
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }
    }
  }

  function initCartDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.dataset.mrReady) return;
    drawer.dataset.mrReady = '1';
    var products = drawer.querySelector('[data-products]');

    function refresh() {
      var data = cartData(drawer);
      renderTiers(drawer, data);
      renderTotals(drawer, data);
    }

    if (products && 'MutationObserver' in window) {
      new MutationObserver(refresh).observe(products, { childList: true });
    }
    refresh();

    drawer.addEventListener('click', function (evt) {
      var btn = evt.target.closest('[data-mr-remove]');
      if (!btn) return;
      evt.preventDefault();
      var key = btn.dataset.key;
      var row = btn.closest('.cart__item');
      if (row) row.style.opacity = '0.4';
      fetch((window.theme && theme.routes && theme.routes.cartChange) || '/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        })
        .catch(function () {
          window.location.href = btn.getAttribute('href') || '/cart';
        });
    });
  }

  /* ------------------------------------------------------------------------
     Start
     ------------------------------------------------------------------------ */
  /* ------------------------------------------------------------------------
     Hero-video zonder video: tekst toch tonen (anders blijft die onzichtbaar)
     ------------------------------------------------------------------------ */
  function initEmptyHeroes(root) {
    root.querySelectorAll('.video-parent-section').forEach(function (sec) {
      if (!sec.querySelector('.video-div')) sec.classList.add('loaded');
    });
  }

  function initAll(root) {
    root = root || document;
    initEmptyHeroes(root);
    root.querySelectorAll('[data-mr-countdown]').forEach(initCountdown);
    root.querySelectorAll('[data-mr-eta]').forEach(initEta);
    root.querySelectorAll('[data-mr-reviews]').forEach(initReviews);
    bindVariantLabels(root);
    var startMarquees = function () {
      root.querySelectorAll('[data-mr-marquee]').forEach(initMarquee);
    };
    if (document.readyState === 'complete') {
      startMarquees();
    } else {
      window.addEventListener('load', startMarquees);
      setTimeout(startMarquees, 1500);
    }
    initCartDrawer();
  }

  ready(function () {
    initAll(document);
  });

  // Thema-editor: secties opnieuw starten na bewerken
  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });
})();
